import React from 'react';
import { number } from 'prop-types';
import classNames from 'classnames/bind';

import { ProductPodPlaceholder } from '@thd-olt-component-react/product-pod';

import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { CategoryProducts } from '../CategoryProducts/CategoryProducts';
import styles from './special-buy-carousel.module.scss';

const cNames = classNames.bind(styles);

const SpecialBuyCarousel = ({ bannerWidth }) => {
  const { categories, isSpecialBuyDataLoading } = useSpecialBuy();

  const carouselClassNames = cNames('special-buy-carousel', {
    'special-buy-carousel--hidden': !categories.length && !isSpecialBuyDataLoading,
  });

  return (
    <section className={carouselClassNames}>
      {isSpecialBuyDataLoading ? (
        <ProductPodPlaceholder />
      ) : (
        <>
          {categories.map((category) => (
            <CategoryProducts
              key={category.categoryId}
              category={category}
              bannerWidth={bannerWidth}
            />
          ))}
        </>
      )}
    </section>
  );
};

SpecialBuyCarousel.displayName = 'SpecialBuyCarousel';

SpecialBuyCarousel.propTypes = {
  bannerWidth: number.isRequired,
};

export { SpecialBuyCarousel };
